var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"copyRight"},[_c('div',{staticClass:"main-container"},[_c('div',{staticClass:"image"},[_c('v-img',{attrs:{"src":_vm.images.logo}})],1),_vm._m(0)])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"copyRight"},[_c('i',{staticClass:"fa fa-copyright"}),_c('span',[_vm._v("جميع الحقوق محفوظة لبرامج النوعية ")])])
}]

export { render, staticRenderFns }